import { type FC, useContext } from "react";
import { type TableColumnMap, TableComponent } from "../../Forms/DragDrop/ComponentBases/TableComponent";
import { DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue } from "../../Forms/DragDrop/ReorderableTableSettings";

const COLUMN_DEFINITIONS: TableColumnMap = {
    name: {
        style: {
            textAlign: "right",
        },
        format: (value, row) => {
            return (
                <>
                    {typeof row.indicator === "string" && (
                        <span
                            style={{
                                display    : "inline-block",
                                marginRight: "0.25rem",
                            }}
                        >
                            [{row.indicator}]
                        </span>
                    )}
                    {value}
                </>
            );
        },
    },
    amount: {
        style: {
            width: "6em",
        },
    },
};

export const ReceiptSurchargeComponent: FC<ComponentOptions> = ({
    value,
    style,
}) => {
    const { surcharges } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);

    if(!hasColumnsValue(value)) {
        return error;
    }

    if(!Array.isArray(surcharges)) {
        return error;
    }

    return (
        <TableComponent
            noHeader
            columns={COLUMN_DEFINITIONS}
            value={value.columns}
            data={surcharges}
            style={style}
        />
    );
};
